import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import ExperienceType from '@/constants/ExperienceType';
import ExperienceRatingsConfig from '@/constants/interactions/ExperienceRatingsConfig';
import InteractionMethodFieldConfig from '@/constants/interactions/InteractionMethodFieldConfig';
import InteractionType from '@/constants/InteractionType';

const EXPERIENCE_TYPE = 'experience';
const INTERACTION_TYPE = 'interaction';

export default function InteractionEnumIcon({
  classes,
  enumValue,
  iconOnly,
  type,
}) {
  let icon;
  let text;

  if (type === EXPERIENCE_TYPE) {
    ({ icon, text } =
      ExperienceRatingsConfig.find(
        ({ descriptor }) => descriptor === enumValue,
      ) || {});
  }

  if (type === INTERACTION_TYPE) {
    ({ icon, text } =
      InteractionMethodFieldConfig.find(({ value }) => {
        return value === enumValue;
      }) || {});
  }

  return (
    <>
      {icon && (
        <img
          className={classnames('h-4 w-4', {
            'mr-2': !iconOnly,
            inline: !iconOnly,
            [classes?.icon]: classes?.icon,
          })}
          alt=""
          src={icon}
          data-testid={`interaction-enum-icon-${enumValue}`}
        />
      )}
      {!iconOnly && text}
    </>
  );
}

InteractionEnumIcon.propTypes = {
  classes: PropTypes.shape({
    icon: PropTypes.string,
  }),
  enumValue: PropTypes.oneOf([
    ...Object.values(ExperienceType),
    ...Object.values(InteractionType),
  ]).isRequired,
  iconOnly: PropTypes.bool,
  type: PropTypes.oneOf([EXPERIENCE_TYPE, INTERACTION_TYPE]).isRequired,
};

InteractionEnumIcon.defaultProps = {
  classes: null,

  iconOnly: false,
};

InteractionEnumIcon.experienceType = EXPERIENCE_TYPE;
InteractionEnumIcon.interactionType = INTERACTION_TYPE;
